function setCookieValues(name, value) {
	if ((name === 'gemeinden') && (value !== '')) {
		var isCmpEnabled = (typeof ubCmp !== 'undefined') && (typeof ubCmp.isVendorAccepted === 'function');

		if (!isCmpEnabled || ubCmp.isVendorAccepted('gemeinden_selected_value')) {
			document.cookie = "gemeinden_selected_value="+value+"; max-age=259200; path=/";
			init_header();
			console.log(value);
		}
	}
}

function closeAllSelect(elmnt) {
	/*a function that will close all select boxes in the document,
	except the current select box:*/
	var x, y, i, arrNo = [];
	x = document.getElementsByClassName("select-items");
	y = document.getElementsByClassName("select-selected");

	for (i = 0; i < y.length; i++) {
		if (elmnt == y[i]) {
			arrNo.push(i);
		} else {
			y[i].classList.remove("select-arrow-active");
		}
	}

	for (i = 0; i < x.length; i++) {
		if (arrNo.indexOf(i)) {
			x[i].classList.add("select-hide");
		}
	}
}

/* CUSTOM SELECTBOX HANDLING */
function changeSelectedIndex ( obj ) {
	var y, i, k, s, h;
	s = obj.parentNode.parentNode.getElementsByTagName("select")[0];
	h = obj.parentNode.previousSibling;

	for (i = 0; i < s.length; i++) {
		if (s.options[i].innerHTML == obj.innerHTML) {
			s.selectedIndex = i;
			h.innerHTML = obj.innerHTML;
			y = obj.parentNode.getElementsByClassName("same-as-selected");

			for (k = 0; k < y.length; k++) {
				y[k].removeAttribute("class");
			}

			obj.setAttribute("class", "same-as-selected");
			$(s).trigger('change');
			break;
		}
	}

	setCookieValues(s.name, s.options[s.options.selectedIndex].value);
	h.click();
}

function selectBoxClick( obj, d ) {
	closeAllSelect(obj);
	obj.nextSibling.classList.toggle("select-hide");
	obj.classList.toggle("select-arrow-active");
	// if ( obj.previousElementSibling.value != '' && d != obj.previousElementSibling.value ) {
	//	 openPopUpOverlay(obj.textContent, obj.previousElementSibling.value);
	//	 d = obj.previousElementSibling.value;
	// }
}


(function () {
	var x, i, j, selElmnt, a, b, c, d;
	/*look for any elements with the class "container-selectbox":*/
	x = document.getElementsByClassName("container-selectbox");

	for (i = 0; i < x.length; i++) {
		selElmnt = x[i].getElementsByTagName("select")[0];
		/*for each element, create a new DIV that will act as the selected item:*/
		a = document.createElement("DIV");
		a.setAttribute("class", "select-selected");

		if (selElmnt.selectedIndex > -1) {
			a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
		}

		x[i].appendChild(a);
		/*for each element, create a new DIV that will contain the option list:*/
		b = document.createElement("DIV");
		b.setAttribute("class", "select-items select-hide");

		for (j = 0; j < selElmnt.length; j++) {
			if (!$(selElmnt.options[j]).attr("hidden")) {
				/*for each option in the original select element,
				create a new DIV that will act as an option item:*/
				c = document.createElement("DIV");
				c.innerHTML = selElmnt.options[j].innerHTML;
				c.addEventListener("click", function (e) {
					/*when an item is clicked, update the original select box,
					and the selected item:*/
					changeSelectedIndex(this);
				});
				b.appendChild(c);
			}
		}

		x[i].appendChild(b);

		a.addEventListener("click", function(e) {
			/*when the select box is clicked, close any other select boxes,
			and open/close the current select box:*/
			e.stopPropagation();
			selectBoxClick(this, d);
		});
	}

	/*if the user clicks anywhere outside the select box,
	then close all select boxes:*/
	document.addEventListener("click", closeAllSelect);

	// Move infotexts to the end of the select box
	$(".container-selectbox").each(function () {
		$box = $(this);
		$box.find('.container-selectbox__infotext').each(function () {
			$box.append(this);
		});
	});
})();

// Show info text on selection
$(function () {
	$('.container-selectbox').each(function () {
		var $selectBox = $(this),
			$infoTexts = $selectBox.find('.container-selectbox__infotext');

		$infoTexts.first().show();
		$selectBox.find('select').change(function () {
			var currentValue = this.value;
			$infoTexts.each(function () {
				var $infoText = $(this);
				$infoText.data('for-value') === currentValue ? $infoText.show() : $infoText.hide();
			});
		});
	});
});
